import API from 'services/api';

export const getPartnerReservation = (calculationId: string) =>
  API.get(`/api/accommodation/calculations/services/${calculationId}/partnerReservation`).then(
    response => response?.data,
  );
